export default __webpack_public_path__ + "img/bg_marketing-ab07fce5cfeb6d4aad7f2534ec782784.png";